var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-0.645 -0.645 18 18",
    height: 18,
    width: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.29
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.355,
    cy: 8.355,
    r: 5.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.355,
    cy: 8.355,
    r: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.555 8.355h1.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.355 13.555v1.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.155 8.355h-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.355 3.155v-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.032 12.032 1.131 1.131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.678 12.032 -1.131 1.131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.678 4.678 -1.131 -1.131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.032 4.678 1.131 -1.131"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/gear.44815faf5db5af851a9eca961d824425.svg";
export { ForwardRef as ReactComponent };